import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import it from './it.json'
import pl from './pl.json'
import { createI18n } from "vue-i18n"

export const defaultLocale = 'de'

export const languages = {
  de: de,
  en: en,
  es: es,
  fr: fr,
  it: it,
  pl: pl,
}

const messages = Object.assign(languages)

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: 'de',
  allowComposition: true,
  messages
});

export default i18n